import { Navigate, Outlet, useLocation } from 'react-router';
import { routes } from 'routes/routes';
import { useIsAuthenticated } from 'features/auth';

type P = {
  requiredAuthenticatedStatus?: boolean;
};

const AuthenticatedGuard = ({ requiredAuthenticatedStatus = true }: P) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { pathname, search, state } = useLocation();

  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated === requiredAuthenticatedStatus) {
    return <Outlet />;
  }

  if (requiredAuthenticatedStatus) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    return <Navigate state={{ originalState: state, referrer: pathname + search }} to={routes.login.index} />;
  }

  return null;
};

export default AuthenticatedGuard;
